import {
  PictureNormalRechargeCard,
  PictureNormalRechargeWrapper,
} from "./atom";
import { useClientTopUpStore } from "../../store";
import { useEffect, useState } from "react";
import { ActivityRuleAndCoupon, CommonCardListWrapper } from "../../atom";
import { PictureNormalRechargeInfo, rechargeRules } from "../../constants";
import RuleModal from "../rule-modal";
import { NewUserWelfare } from "../new-user-welfare";
import { Whether } from "project-config/constants";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import RechargeVoucherModal from "../recharge-voucher-modal";

export function PictureNormalRecharge() {
  const [openRuleDrawer, setOpenRuleDrawer] = useState(false);
  const [checkCardPrice, setCheckCardPrice] = useState(
    PictureNormalRechargeInfo[0]
  );
  const {
    setRechargeAmount,
    isCheckCard,
    setIsCheckCard,
    rechargeSecondActiveName,
  } = useClientTopUpStore();
  const { userProperty } = useUserPropertyStore();

  useEffect(() => {
    setCheckCardPrice(PictureNormalRechargeInfo[0]);
    if (rechargeSecondActiveName === "client-second-tab-first-recharge") return;
    setRechargeAmount(PictureNormalRechargeInfo[0]);
    setIsCheckCard(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rechargeSecondActiveName]);

  return (
    <PictureNormalRechargeWrapper>
      <ActivityRuleAndCoupon>
        <RuleModal
          type="recharge"
          ruleList={rechargeRules}
          open={openRuleDrawer}
          setRuleOpen={(val) => {
            setOpenRuleDrawer(val);
          }}
        />
        <RechargeVoucherModal />
      </ActivityRuleAndCoupon>
      {userProperty.picRechargeOver === Whether.No && <NewUserWelfare />}
      <CommonCardListWrapper>
        {PictureNormalRechargeInfo.map((item) => {
          const isActiveCard = checkCardPrice === item && isCheckCard;
          return (
            <PictureNormalRechargeCard
              isActive={isActiveCard}
              onClick={() => {
                setCheckCardPrice(item);
                setIsCheckCard(true);
                setRechargeAmount(item);
              }}
              key={item}
            >
              <div className="price-wrapper">
                <span className="symbol">¥</span>
                <span>{item}</span>
              </div>
            </PictureNormalRechargeCard>
          );
        })}
      </CommonCardListWrapper>
    </PictureNormalRechargeWrapper>
  );
}
